/*
 * @Author: your name
 * @Date: 2022-03-09 14:16:28
 * @LastEditTime: 2022-03-28 11:30:10
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \kares_pad\src\i18n\language\yh_zh.js
 */
export default {
  basics: {
    Cancel: '取 消',
    Confirm: '确 定',
    en: '英',
    zh: '中',
    PleaseSelect: '请选择',
    PleaseInput: '请输入内容' // Please enter the content
  },
  schedule: {
    //节目编辑
    Screenshot: '截图',
    ProgramName: '节目名称',
    Structure: '组织结构',
    Resolution: '分辨率',
    CreationTime: '创建时间',
    operate: '操作',
    AllLoaded: '已加载全部素材', // All materials loaded
    materialsLoaded: '点击加载更多素材',
    NewProgram: '新建节目', // New program
    DelProgram: '请问是否要永久删除当前选中节目？', //Permanently delete the currently selected program?
    DeleteMedia: '删除媒体',  // Delete media
    DeleteProgram: '删除节目',
    //高级发布
  },
  review: {
    Screenshot: '截图',
    ProgramName: '节目名称',
    Structure: '组织结构',
    Resolution: '分辨率',
    CreationTime: '创建时间',
    operate: '操作',
    Review: '审核', // Review
    Check: '查看', // Check
    ProgramMaterial: '节目素材', // Program material
    ProgramPreview: '节目预览', // Program preview
    ReviewContent: '请输入审核内容', // Please enter review content
    Approved: '通过审核', // Approved
    RejectReview: '拒绝通过', // Reject review
    DeleteAll: '确认全部删除?', // Confirm delete all
    Name: '名称', // Name
    Size: '大小', // Size
    Preview: '预览', // Preview
    ProgramReview: '节目审核',
    ReasonRefusal: '请填写拒绝理由!', // Please fill in the reason for refusal
    number: '未选择发布单号',  // No release ticket number is selected
  },
  system: {
    // 组织结构
    StructureName: '组织结构名称',
    Operate: '操作',
    NewStructure: '新增组织结构',
    DeleteStructure: '删除组织结构',
    Structure: '组织结构',
    MsgDeleteStructure: '请问是否要永久删除当前',
    OnDevice: '开启设备',
    OffDevice: '关闭设备',
    inquiry: '请问是否要',
    on: '开启',
    off: '关闭',
    slaveDevice: '当前或从属设备',
    CloseCurrent: '关闭当前',
    CloseSlave: '关闭从属',
    OpenCurrent: '开启当前',
    OpenSlave: '开启从属',
    // 用户管理
    Account: '账号',
    Name: '姓名',
    Role: '角色',
    Grade: '等级',
    Remark: '备注',
    RoleName: '角色名称',
    Password: '密码',
    ConfirmPass: '确认密码',
    Mail: '邮箱',
    DeleteUser: '删除用户',
    DeleteRole: '请问是否要永久删除当前角色',
    UnblockDevice: '解封设备',
    banDevice: '封禁设备',
    Unblock: '解封',
    ban: '封禁',
    BanTheCurrent: '封禁当前',
    BannedAffiliate: '封禁从属',
    ReleaseTheCurrent: '解禁当前',
    ReleaseTheSubordinate: '解禁从属',
    AddUser: '新增用户',
    ModifyUser: '修改用户',
    inputPassword: '请输入确认密码',
    noPassword: '两次输入密码不一致!',
    inputName: '请输入姓名',
    RoleEmpty: '角色名称不能为空',
    StructureEmpty: '组织结构不能为空',
    AccountEmpty: '账号不允许为空',
    AccountAstrict: '账号中只能包含数字、字母、下划线!',
    AccountLength: '请设置账号长度为3~20个字符!',
    AccountRegistered: '当前账号已注册，请重输入!',
    // 角色管理
    AddRole: '新增角色',
    RoleRemark: '角色备注',
    RightConfig: '权限配置',
    DelRole: '删除角色',
    // 系统设置
    imageSize1: '建议尺寸为920x940像素的PNG格式图片',// Suggest 920x940 pixels PNG format
    ReplacePicture: '替换图片', //  Replace picture
    LoginLogo: '登录页面LOGO', // Login page logo
    imageSize2: '建议尺寸为360x80像素的PNG格式图片', //Suggest 360x80 pixels PNG format
    SystemLogo: '系统页面LOGO', // System page logo
    systemSettings: '其他系统设置', // 	Other system settings
    configInformation: '其他配置信息', // Other config information
    DailyLimit: '每日申请上限', // Daily application limit
    UploadedType: '上传头像图片只能是 PNG 格式', // Uploaded avatar image can only PNG format!
    UploadedSize: '上传头像图片大小不能超过 2MB!',//Size of the uploaded avatar image cannot exceed 2MB!
    // 节点管理
    addNode: '新增节点', //Add node
    EnglishName: '英文名称', //English name
    ChineseName: '中文名称', //Chinese name
    delNode: '请问是否要永久删除当前节点？',
    // 软件授权
    AuthorizationType: '授权码类型', // Authorization code type
    Model: '型号', // Model
    Date: '日期', // Date
    AuthorizationCode: '授权码', // Authorization Code
    NewAccounts: '新建账号' // New accounts
  },
  // 节目编辑
  programEditing: {
    Setting: '设置', // Setting
    Save: '保存', // Save
    Release: '发布', // Release
    Quit: '退出', // Quit
    ExitEditProgram: '退出将丢弃当前编辑的节目', // Exit will discard  currently edited program
    DragMaterial: '请将素材文件拖拽到此处', // Drag the material file here
    SaveWait: '拼命截图保存中请等待...', // Screenshots and saving, please wait ...
    ProgramList: '节目列表', // Program list
    multimedia: '多媒体', // multimedia
    AddMultimedia: '添加多媒体', // Add multimedia
    Insert: '插入到当前位置', // Insert at current position
    properties: '窗口素材属性', // Window material properties
    materialNull: '请添加素材至窗口', // Please add material to window
    Uploaded: '上传素材', // Uploaded material
    AllLoaded: '已加载全部素材', // All materials loaded
    materialsLoaded: '点击加载更多素材',
    Text: '文本', // Text
    Digital: '数字时钟', // Digital clock
    Analog: '模拟时钟', // Analog clock
    Weather: '天气', // Weather
    Timing: '正计时', // Timing
    Countdown: '倒计时', // Countdown
    StreamMedia: '流媒体', // Stream media
    RSS: 'RSS', //  RSS
    Window: '窗口', //  Window
    Picture: '图片', // Picture
    Video: '视频', // Video
    Delete: '删除', // Delete
    Webpage: '网页',
    OneLayerUp: '向上一层', // One layer up
    OneLayerDown: '向下一层', // One layer down
    Top: '最上层', // Top
    Bottom: '最下层', // Bottom
    Full: '全屏铺满', // Full
    HorizontalFull: '水平铺满', // Horizontal full
    VerticalFull: '垂直铺满', // Vertical full
    VerticalDown: '垂直向下', // Vertical down
    VerticalMiddle: '垂直居中', // Vertical middle
    VerticalTop: '垂直向上', // Vertical top
    HorizontalLeft: '水平靠左', // Horizontal left
    HorizontalCenter: '水平居中', // Horizontal center
    HorizontalRight: '水平靠右', // Horizontal right

    ProgramName: '节目名称', // Program name
    Structure: '组织结构', // Structure
    DeviceType: '设备类型', // Device type
    Resolution: '分辨率', // Resolution
    CustomResolution: '自定义分辨率', // Custom resolution
    Device: '设备', // Device
    SelectDevice: '请选择设备', // Please select device
    SelectTerminal: '选择发布终端', // 
    TerminalName: '终端名称', // Terminal name
    DeviceStatus: '设备状态', // Device status
    Offline: '离线', // Offline
    AdaptiveScreen: '自适应屏幕大小播放', // Adaptive screen size playback
    Tip: '提示', // tip
    Thumbnail: '缩略图', // thumbnail
    Name: '名称', // 
    version: 'P系列设备版本低于<i style="color: red;">(228)</i>仅支持定时发布。请先将节目保存，前往节目管理——高级发布选择定时播放，添加保存好的节目后发布。',

    Title: '标题', // Title
    TimerMode: '计时方式', // Timer mode
    RelativeTime: '相对时间', // Relative time
    AbsoluteTime: '绝对时间', // Absolute time
    DisplayMode: '显示模式', // Display mode
    Day: '天', // Day
    Hour: '时', // Hour
    Minutes: '分', // Minutes
    Second: '秒', // Second
    EditStyle: '显示风格', // Edit style
    DisplayUsage: '显示方式', // display usage
    ARow: '单行', // A row 
    MultiRow: '多行', // Multi-row 
    FontFamily: '字体设置', // Font family
    BackgroundColor: '背景颜色', // Background color
    FontColor: '字体颜色', // Font color
    PlayTime: '播放时长', // Play time
    Describe: '描述文字', // Describe
    HourMark: '时标', // Hour mark 
    HourHand: '时钟', // Hour hand
    MinutesMark: '分标', // Minutes mark 
    MinutesHand: '分钟', // Minutes hand
    background: '背景', // background
    secondHand: '秒钟', // second hand
    DateAndDay: '日期星期', // Date and day
    Display: '显示', // Display
    SelectTimeZone: '选择时区', // Select time zone
    Scale: '比例约束', // Scale
    ConstrainProportions: '约束比例', // Constrain Proportions
    EnterTheAnimation: '入场动画', // Enter the animation
    TheEntryTime: '入场时长', // The entry time
    Data: '日期', // Data
    Time: '时间', // Time
    ChineseCalendar: '农历', // Chinese calendar
    Week: '星期', // Week
    DateFormat: '日期格式', // Date format 
    Font: '字体', // Font
    Roll: '滚动', // Roll
    FlipOver: '翻页', // Flip over
    Motionless: '静止', // Motionless
    RollingDirection: '滚动方向', // Rolling direction
    RollingVelocity: '滚动速度', // Rolling velocity
    FromLeftToRight: '从左到右', // From left to right
    FromRightToLeft: '从右到左', // From right to left
    FromTopToBottom: '从上到下', // From top to bottom 
    FromTheBottomUp: '从下到上', // From the bottom up 
    Attribute: '属性', // Attribute
    AttendedMode: '连接方式', // Attended mode
    EndToEnd: '首尾相连', // End to end
    VolumeAdjust: '音量调节', // Volume adjust
    Duration: '视频时长', // Duration
    Address: '地址', // Address
    City: '城市', // City
    Temp: '温度', // Temp
    WindPower: '风力', // Wind power
    Humidity: '湿度', // Humidity
    DressingIndex: '穿衣指数', // Dressing Index
    PlayTheWay: '播放方式',
    TimeFormat1: '00:00:00:00',
    TimeFormat2: '00D00H00M00S'
  }
}
